import './newsletterSignupForm';
import './NeogenRecaptchaV3ElementBlock';
import './choiceElementBlock';

(function() {
    
    window.addEventListener('DOMContentLoaded', (event) => {

        // make jQuery.validate mark bootstarp forms with correct jQuery classes
        jQuery.validator.setDefaults({
            highlight: function ($element) {
                jQuery($element).addClass('is-invalid');
            },
            unhighlight: function ($element) {
                jQuery($element).removeClass('is-invalid');
                jQuery($element).siblings('.field-validation-error').empty();
            },
            errorElement: 'div',
            errorClass: 'error-message',
            errorPlacement: function (error, $element) {
                if ($element.parent('.input-group').length) {
                    error.insertBefore($element.parent());
                } else {
                    error.insertBefore($element);
                }
            }
        });

        const newAccountForms = document.querySelector('.js-new-account-registration');
        if (!newAccountForms) return;
        const newAccountRegister = newAccountForms.querySelector('.js-new-account-register');
        const newAccountBillTo = newAccountForms.querySelector('.js-new-account-bill-to');
        const newAccountShipTo = newAccountForms.querySelector('.js-new-account-ship-to');
        const useBillToForShipTo = newAccountForms.querySelector('.js-use-bill-to-for-ship-to');

        const copyBillToInShipTo = (billToForm, shipToForm) => {
            Array.from(billToForm.querySelectorAll('.form-control')).forEach(formField => {
                let fieldId = formField.getAttribute('id').substring(4);
                const shipToField = shipToForm.querySelector(`#Ship${fieldId}`);
                shipToField.value = formField.value;
            });
        };
        
        //const clearForm = (form) => {
        //    Array.from(form.querySelectorAll('.form-control')).forEach(formField => {
        //        formField.value = '';
        //    });
        //};

        const handlerUseBillToForShipTo = () => {
            useBillToForShipTo.onclick = (event) => {
                if (event.target.checked) {
                    copyBillToInShipTo(newAccountBillTo, newAccountShipTo);
                }
                Array.from(newAccountShipTo.querySelectorAll('.form-control')).forEach(shipToField => {
                    shipToField.toggleAttribute("readonly");
                });
            }
        };

        handlerUseBillToForShipTo();
    });
    
})();

